import { DialogContent } from '@mui/material';

import { GDMDialogContentComponent } from './GDMDialogContent.type';

/* TODO: Implement component using GDM default design */
const GDMDialogContent: GDMDialogContentComponent = props => <DialogContent {...props} />;

export default GDMDialogContent;
